import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";

//blog en realidad es un artículo 😅

export const getBlogs = async () => {
  try {
    const { data } = await _axios.get("/api/blogs");
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getBlogsByPage = async (page) => {
  try {
    const { data } = await _axios.get(`/api/blogs?page=${page}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const createBlog = async (blog) => {
  try {
    const { data } = await _axios.post("/api/blogs?depth=1", blog);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateBlog = async (blogId, blog) => {
  try {
    const { data } = await _axios.patch(`/api/blogs/${blogId}?depth=1`, blog);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteBlogImage = async (imageId) => {
  try {
    const { data } = await _axios.delete(`/api/blogPhotos/${imageId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const deleteBlog = async (blogId) => {
  try {
    const { data } = await _axios.delete(`/api/blogs/${blogId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const uploadBlogImage = async (props) => {
  const formData = new FormData();
  formData.append("alt", props.alt);
  formData.append("file", props.file);

  try {
    const { data } = await _axios.post(`/api/blogPhotos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}